import React from 'react';
import OrderCommitted from 'components/Tvendo/Sale/Operations/OrderWebMovil/OrderWebMovil.js';
import { ConstantPermissions } from 'contexts/useConstant';

export default function () {
  return (
    <OrderCommitted
      type="C"
      title="comprometidos"
      permission={{
        show: ConstantPermissions.ORDM_ORDERS_SHOW,
        store: '',
        annular: ConstantPermissions.ORDM_ORDERS_ANNULAR_COMMITED_ORDER,
        approve: ConstantPermissions.ORDM_ORDERS_APPROVE_COMMITED_ORDER
      }}
    />
  );
}
